import axios from "axios";
import Config from "./config";
import authHeader from "./authHeader";

const jobList = (limit, offest, skillsName, titleName, locationName) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/portal-job-search/?company_domain=${"http://ndz.yvi.ai"}&limit=${
        limit ? limit : ""
      }&offset=${offest ? offest : ""}&skills=${
        skillsName ? skillsName : ""
      }&locations=${locationName ? locationName : ""}&title=${
        titleName ? titleName : ""
      }`,
    {
      headers: authHeader(),
    }
  );
};
const autofill = (serachValue) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/search-autofill/?company_domain=${"http://ndz.yvi.ai"}&search_string=${serachValue}`,
    {
      headers: authHeader(),
    }
  );
};
const searchJob = (skillsName, titleName, locationName) => {
  // const skills = JSON.stringify(selectedValue.skills)

  // console.log("skills",skills);
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/portal-job-search/?skills=${
        skillsName ? skillsName : ""
      }&locations=${locationName ? locationName : ""}&title=${
        titleName ? titleName : ""
      }&company_domain=${"http://ndz.yvi.ai"}`,
    {
      headers: authHeader(),
    }
  );
};
const getJobInfo = (id) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/portal-job-view/${id}/?company_domain=${"http://ndz.yvi.ai"}`,
    {
      headers: authHeader(),
    }
  );
};
const applyForJob = (job_id) => {
  return axios.post(
    Config.API_URL + `api/v1/jobs/job-apply/`,
    {
      job: job_id,
      //company_domain : "http://ndz.yvi.ai"
    },
    {
      headers: authHeader(),
    }
  );
};
const addToCart = (job_id) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/candidate-job-save/`,
    {
      job: job_id,
      //company_domain : "http://ndz.yvi.ai"
    },
    {
      headers: authHeader(),
    }
  );
};
const cartList = (filterData, serachString) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/candidate-save-job-list/?search=${
        serachString ? serachString : ""
      }&status=${filterData ? filterData : ""}`,
    {
      headers: authHeader(),
    }
  );
};
const deleteCart = (job_id) => {
  return axios.delete(
    Config.API_URL + `api/v1/candidates/candidate-job-save/${job_id}`,
    {
      headers: authHeader(),
    }
  );
};
const referCandidates = (job_id, resumes) => {
  console.log("list", resumes);

  const formData = new FormData();
  resumes.forEach((file, index) => {
    formData.append("resumes", file);
  });
  // formData.append("resumes", JSON.stringify(resumes));
  formData.append("job", job_id);

  return axios.post(
    Config.API_URL + `api/v1/candidates/refer-candidates/`,
    formData,
    {
      headers: authHeader(),
    }
  );
};
const getReferredCandidates = (jobId) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/list-referred-candidates/?job_id=${jobId}`,
    {
      headers: authHeader(),
    }
  );
};
const getReferredJobDetails = (candiadteId, jobId) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/application-status/${candiadteId}/${jobId}`,
    {
      headers: authHeader(),
    }
  );
};
const getSuggestedJobs = (jobId) => {
  return axios.get(
    Config.API_URL +
      `api/v1/candidates/career-relatedjobs-list/?job_id=${jobId}`,
    {
      headers: authHeader(),
    }
  );
};
const JobService = {
  jobList,
  autofill,
  searchJob,
  getJobInfo,
  applyForJob,
  addToCart,
  cartList,
  deleteCart,
  referCandidates,
  getReferredCandidates,
  getReferredJobDetails,
  getSuggestedJobs,
};
export default JobService;
